import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentPageHeader, ExtraHeaderPage } from '../../molecules/page-header/ContentPageHeader';
import { IconCreateBlack } from '../../../assets';
import { CARTNER_CONVOS } from '../../../constants/define/translation';

interface CartnerConvosHeaderProps {
  setIsOpenModal: Function;
}

export const CartnerConvosHeader = (props: CartnerConvosHeaderProps) => {
  const { t } = useTranslation(CARTNER_CONVOS);

  const extra: ExtraHeaderPage[] = [
    {
      key: 1,
      text: t('header.buttonCreate'),
      bgWhite: 'true',
      onClick: () => props.setIsOpenModal(true),
      icon: <IconCreateBlack />,
    },
  ];

  return <ContentPageHeader title={t('header.title')} extra={extra} sortingEnabled />;
};
